<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table-list"></i>
        WFDetector(Web Forgery Detectior) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WFDetector</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WFDetect(Web Forgery Detection) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="module_check_1" :value="info && info.from && info.from.alive + info.from.deleted > 0 ? info.from.alive : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> 현황</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>사용중 :
                  <animated-number ref="module_check_1" :value="info && info.from ? info.from.alive + info.from.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>미사용 :
                  <animated-number ref="module_check_2" :value="info && info.from && info.from.deleted > 0 ? info.from.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>전체 :
                  <animated-number ref="module_check_2" :value="info && info.from && info.from.deleted > 0 ? info.from.alive + info.from.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <animated-number ref="server_check_1" :value="info && info.server && info.server.alive > 0 ? info.server.alive : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> 서버</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>사용중 :
                  <animated-number ref="server_check_2" :value="info && info.server.alive && info.server.alive > 0 ? info.server.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>미사용 :
                  <animated-number ref="server_check_3" :value="info && info.server.deleted && info.server.deleted > 0 ? info.server.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>전체 :
                  <animated-number ref="server_check_4" :value="info && info.server.alive && info.server ? info.server.alive + info.server.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-info">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="domain_check_1" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> Domain</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>사용중 :
                  <animated-number ref="domain_check_2" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>미사용 :
                  <animated-number ref="domain_check_3" :value="info && info.domain && info.domain.deleted > 0 ? info.domain.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>전체 :
                  <animated-number ref="domain_check_4" :value="info && info.domain && info.domain.alive > 0 ? info.domain.alive + info.domain.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                    <animated-number ref="detect_check_1" :value="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 탐지</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <animated-number ref="detect_check_2" :value="info && info.detect && info.detect.day > 0 ? info.detect.day : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>최근 7일 :
                  <animated-number ref="detect_check_3" :value="info && info.detect && info.detect.week > 0 ? info.detect.week : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>이번달 :
                  <animated-number ref="detect_check_4" :value="info && info.detect && info.detect.month > 0 ? info.detect.month : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card ref="_ms" v-else>
      <b-row>
        <b-col class="title">
          에이전트 상태 (Max 100)
          <b-button class="float-right ml-2" size="m" variant='success' to="/downloads">새로운 서버 등록</b-button>
          <b-button class="float-right ml-2" size="m" variant='success' to="/wmds/site">새로운 도메인 등록</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <agent-item v-for="(item, index) in agents" :key="index" :ref="`_agent_${index}`" :agent="item"></agent-item>
      </b-row>
      <b-row v-if="this.count == 0" style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
              <h3 class="mb-0">설치된 에이전트가 없습니다</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
